<template>
  <div class="qualification-upload">
    <el-upload
      v-if="!disabled"
      action="#"
      accept="image/*"
      :show-file-list="false"
      :http-request="upload"
      :before-upload="beforeUpload"
    >
      <el-button size="small" type="primary" icon="el-icon-upload2">
        上传图片
      </el-button>
    </el-upload>
    <div class="preview-wrap">
      <el-link v-if="value" :href="value" target="_blank" :underline="false">
        <el-image :src="value" fit="contain" class="preview-image">
          <div slot="error" class="image-error">
            <i class="el-icon-picture-outline" /> 查看附件
          </div>
        </el-image>
      </el-link>
      <span v-else class="empty-text">暂无图片</span>
    </div>
  </div>
</template>

<script>
import { uploadCompanyFile } from "@/api/company";

export default {
  name: "CompanyQualificationUpload",
  props: {
    value: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    beforeUpload(file) {
      const isImage =
        String(file.type || "").startsWith("image/") ||
        /\.(jpe?g|png|gif|bmp|webp)$/i.test(file.name);
      if (!isImage) this.$message.error("只能上传图片文件");
      return isImage;
    },
    async upload(options) {
      const data = new FormData();
      data.append("fileVal", options.file);
      try {
        const res = await uploadCompanyFile(data);
        const url =
          res &&
          (typeof res.data === "string" ? res.data : res.data && res.data.url);
        if (!url) throw new Error("upload failed");
        this.$emit("input", url);
        options.onSuccess(res);
        this.$message.success("上传成功");
      } catch (error) {
        options.onError(error);
        this.$message.error("上传失败");
      }
    }
  }
};
</script>

<style scoped>
.qualification-upload {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}
.preview-wrap {
  width: 200px;
  min-height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fafafa;
}
.preview-image {
  width: 198px;
  height: 110px;
  display: block;
}
.image-error,
.empty-text {
  color: #909399;
  font-size: 13px;
}
</style>
